import { useEffect, useState } from "react";

export function PainelFrota() {
  const serviceAccountToken = "glsa_wAGux51D01RmxYttUDEfiNjkVaAri3ir_a7ed1c8a";
  const dashboardUrl =
    "https://grafana.tlpservicos.com.br/d/befnenwcdigaoa/dash?orgId=1&from=now-24h&to=now&timezone=browser&var-refresh_1min=1741815393&refresh=30m&kiosk";
  const urlWithAuth = `${dashboardUrl}&authToken=${serviceAccountToken}`;

  const [height, setHeight] = useState("100vh");

  // Atualiza a altura do iframe quando o componente é montado ou quando a janela é redimensionada
  useEffect(() => {
    const updateHeight = () => {
      // Considera possíveis elementos de header/footer ou outras margens na página
      // Você pode ajustar o valor subtraído conforme necessário
      const navbarHeight = 0; // Ajuste este valor se houver uma navbar
      const footerHeight = 0; // Ajuste este valor se houver um footer
      const newHeight = window.innerHeight - navbarHeight - footerHeight;
      setHeight(`${newHeight}px`);
    };

    // Configura a altura inicial
    updateHeight();

    // Adiciona listener para redimensionamento
    window.addEventListener("resize", updateHeight);

    // Limpa o listener quando o componente for desmontado
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <div className="dashboard-container" style={{ height: "100%", overflow: "hidden" }}>
      <iframe
        src={urlWithAuth}
        width="100%"
        height={height}
        frameBorder="0"
        title="Grafana Dashboard"
        style={{ display: "block" }} // Elimina espaços extras
      />
    </div>
  );
}
